import $ from 'jquery';

export function setUserPoints(xVal, yVal, stepDiff) {
  return (userPoint) => {
    if (Math.abs(userPoint.x - xVal) < (stepDiff / 2)) {
      userPoint.y = yVal;
      userPoint.defined = true;
    }

    return userPoint;
  }
}

export function getGapData(res, item, index, nodes) {
  if (
    !res &&
    index > 0 &&
    index < nodes.length - 1 &&
    !item.defined &&
    nodes.find((d, i) => d.defined && i > index)
  ) {
    res = {
      minIndex: index - 1,
      maxIndex: nodes.reduce((r, d, i) => {
        if (d.defined && i > index && r === -1) {
          r = i
        }

        return r;
      }, -1)
    }
  }

  return res;
}

export function yGetter(pointA, pointB) {
  const gradient = (pointB.y - pointA.y) / (pointB.x - pointA.x);
  return x => gradient * (x - pointA.x) + pointA.y;
}

export function fillGap(minIndex, maxIndex, getY) {
  return (d, i) => {
    if (!d.defined && i > minIndex && i < maxIndex) {
      d.y = getY(d.x);
      d.defined = true;
    }

    return d;
  }
}

export function calcError(origData, userData, minYValue, maxYValue) {
  // the first value is always correct, thats why we don't want to count it
  const errorSum = userData.slice(1, userData.length).reduce((res, item) => {
    const origDataPoint = origData.find(d => d.x === item.x);
    const maxError = Math.max(origDataPoint.y - minYValue, maxYValue - origDataPoint.y)
    const e = Math.abs(origDataPoint.y - item.y) / maxError;

    return res + e;
  }, 0);

  return (errorSum / (userData.length - 1)) * 100;
}

export async function sendData({ url, chartId, error, userData }) {
  const res = await $.ajax({
    type: 'POST',
    url,
    data: JSON.stringify({
      id: chartId,
      points: userData.map(d => [d.x, d.y]),
      e: error
    }),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json'
  });

  return res;
}

export function hasUserStartedToDraw(userData) {
  const definedData = userData.filter(d => d.defined);
  return definedData.length > 1;
}